function allowInnerScroll() {
  const scrollables = document.querySelectorAll('.secvh__scroll');
  const TOLERANCE = 6;

  scrollables.forEach(el => {
    el.addEventListener(
      'wheel',
      e => {
        if (window.innerWidth <= 960) return;

        const deltaY = e.deltaY || (e.wheelDelta ? -e.wheelDelta : 0);
        if (!deltaY) return;

        const { scrollTop, scrollHeight, clientHeight } = el;

        const atTop = scrollTop <= TOLERANCE;
        const atBottom = scrollTop + clientHeight >= scrollHeight - TOLERANCE;
        const scrollingDown = deltaY > 0;
        const scrollingUp = deltaY < 0;

        const canScrollInside =
          (scrollingDown && !atBottom) || (scrollingUp && !atTop);

        if (canScrollInside) {
          e.stopPropagation();
          return;
        }

        e.preventDefault();

        window.scrollBy(0, deltaY);
      },
      { passive: false }
    );
  });
}

function allowInnerTouch() {
  const scrollables = document.querySelectorAll('.secvh__scroll');
  const TOLERANCE = 6;

  scrollables.forEach(el => {
    let startY = 0;

    el.addEventListener(
      'touchstart',
      e => {
        if (window.innerWidth <= 960) return;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    el.addEventListener(
      'touchmove',
      e => {
        if (window.innerWidth <= 960) return;

        const currentY = e.touches[0].clientY;
        const delta = startY - currentY;

        const { scrollTop, scrollHeight, clientHeight } = el;

        const atTop = scrollTop <= TOLERANCE;
        const atBottom = scrollTop + clientHeight >= scrollHeight - TOLERANCE;
        const scrollingDown = delta > 0;
        const scrollingUp = delta < 0;

        const canScrollInside =
          (scrollingDown && !atBottom) || (scrollingUp && !atTop);

        if (canScrollInside) {
          e.stopPropagation();
        } else {
          e.preventDefault();
          window.scrollBy(0, delta);
        }

        startY = currentY;
      },
      { passive: false }
    );
  });
}

document.addEventListener('DOMContentLoaded', () => {
  allowInnerScroll();
  allowInnerTouch();
});
